module.exports = __webpack_public_path__ + "img/loyalty website-43.9e4522d0.png";